import { useRef, useState, useEffect, forwardRef, SyntheticEvent } from "react";
import { useSelector, useDispatch } from "react-redux"
import { Box } from "@mui/material";
import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { timezones } from './timezonelist'
import { usePbiUpdateUserDetailsMutation, usePbiGetUserDetailsMutation } from '../auth/authApiSlice'
import { selectCurrentUser, selectSelectedReportDetails, selectUserPreference } from "../auth/authSlice"
import { selectUserData } from "../data/dataSlice"
import { setUserData } from '../data/dataSlice'
import { setUserPreference } from '../auth/authSlice'

  const language = [
    {
      value: 'en',
      label: 'English (US)',
    },
    {
      value: 'es',
      label: 'Spanish',
    },
    {
      value: 'fr',
      label: 'French',
    },
    {
      value: 'de',
      label: 'German',
    },
    {
      value: 'dk',
      label: 'Danish (Denmark)',
    },
    {
      value: 'nl',
      label: 'Dutch',
    },
    {
      value: 'it',
      label: 'Italian',
    },
    {
      value: 'gb',
      label: 'English (United Kingdom)',
    },
    {
      value: 'pt',
      label: 'Portuguese',
    },
    {
      value: 'dbe',
      label: 'Dutch (Belgium)',
    },
    {
      value: 'ie',
      label: 'English (Ireland)',
    },
    {
      value: 'fbe',
      label: 'French (Belgium)',
    },
    {
      value: 'mx',
      label: 'Spanish (Mexico)',
    },
    {
      value: 'gde',
      label: 'German (Germany)',
    }
  ];
  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

const UserPreference = ({ openAddSubscription, handleAddSubscriptionClose }) => {
    const user = useSelector(selectCurrentUser)
    const reportEmbeddObj = useSelector(selectSelectedReportDetails)
    const userdata = useSelector(selectUserData)
    const dispatch = useDispatch()

    const [ pbiUpdateUserDetails, { isPBIUpdateUserLoading }] = usePbiUpdateUserDetailsMutation()
    const [ pbiGetUserDetails, { isPBIGetUserLoading }] = usePbiGetUserDetailsMutation()
    const userdatatheme = userdata.theme && userdata.theme.toLowerCase() == "dark" ? true : false;

    const {locale, themedark, timezone} = useSelector(selectUserPreference);
    const [themevalue, setThemeValue] = useState(userdatatheme);
    const [localevalue, setLocaleValue] = useState(locale);
    const [timezonevalue, setTimezoneValue] = useState(timezone);

    const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleThemeChange = (event) => {
    setThemeValue(event.target.checked);
  };

  const handleGetUserDetails = async() => {
    const logggedInDetails = {"loginId": userdata.userName}
    const getUserDetails = await pbiGetUserDetails(logggedInDetails).unwrap() 
    if(getUserDetails) {
      const userpreferencedata = {locale: getUserDetails.language && getUserDetails.language.languageId ? getUserDetails.language.languageId.trim() : 'en', defaultCulture: getUserDetails.language && getUserDetails.language.defaultCulture ? getUserDetails.language.defaultCulture : 'en-US', themedark: getUserDetails.theme && getUserDetails.theme.toLowerCase() == 'dark' ? true : false, timezone: getUserDetails.timeZone ? getUserDetails.timeZone : 'GST'}
      dispatch(setUserData(getUserDetails))
      dispatch(setUserPreference(userpreferencedata))
    }
  }

    const handleUpdateUserProfile = async (updateuserdata) => {
      const getUpdateResponse = await pbiUpdateUserDetails(updateuserdata).unwrap()
    }

  const handleSetUserPreference = () => {
   // const userpreference = {locale: localevalue, themedark: themevalue, timezone: timezonevalue}
    const themevaluestr = themevalue ? "Dark" : "Light"
    const updateuserpreference = {"LoginId": userdata.userName, "CanEdit": userdata.canEdit, "CanCreate": userdata.canCreate, "Language": localevalue, "Theme": themevaluestr, "Timezone": timezonevalue}
 //   dispatch(setUserPreference(userpreference))
    handleUpdateUserProfile(updateuserpreference);
    setTimeout(() => {
      handleGetUserDetails();
    }, 3000);
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 2000);
  }

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  return (
    <Box m={2} width={350}>
            <Typography id="transition-modal-title" variant="h3" component="h2">
            My Preferences
            </Typography>
        <div className="switchdiv1">
            <Stack className="displaynone" direction="row" spacing={1} alignItems="center">
                <Typography>Light Theme</Typography>
                <Switch {...label} checked={false} onChange={handleThemeChange} color="secondary" disabled />
                <Typography>Dark Theme</Typography>
            </Stack>
        </div>
            <TextField
                id="filled-select-currency"
                select
                label="Select Language"
                defaultValue={localevalue}
                helperText="Please select your language"
                variant="filled"
                fullWidth
                className="subscriptionformfeild"
                onChange={(e) => setLocaleValue(e.target.value)}
                >
                {language.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                    {option.label}
                    </MenuItem>
                ))}
                </TextField>
                <TextField
                id="filled-select-timezone"
                select
                label="Select Timezone"
                defaultValue={timezonevalue}
                helperText="Please select your timezone"
                variant="filled"
                fullWidth
                className="subscriptionformfeild"
                onChange={(e) => setTimezoneValue(e.target.value)}
                >
                {timezones.map((option) => (
                    <MenuItem key={option.abbr} value={option.abbr}>
                    {option.label}
                    </MenuItem>
                ))}
                </TextField>
            <Stack className="divlogoutbtn" direction="row" spacing={2}>
              <Button variant="contained" color="primary" onClick={handleSetUserPreference}>SAVE</Button>
              {/* <Button variant="outlined" color="primary">CANCEL</Button> */}
            </Stack>
          <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseAlert}>
            <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
              Your preferences saved succussfully 
            </Alert>
          </Snackbar>
          </Box>
  );
};

export default UserPreference;
